'use client';

import React, { useLayoutEffect, useMemo } from 'react';
import { MobileSearchHeader } from '@/components/layout/MobileSearchHeader';

type HeaderType = 'default' | 'Mini search bar' | 'Expanded search';
type HeaderTab = 'Default' | 'Rent apartments' | 'Read reviews';

export function MobileSearchHeaderWithSpacer(props: { type?: HeaderType; tab?: HeaderTab }) {
  const fallback = useMemo(() => {
    if (props.type === 'default') return 58;
    if (props.type === 'Expanded search') return 194;
    return 76; // Mini search bar default
  }, [props.type]);

  // Drive a global CSS variable so *any* page (including nested scroll containers) gets correct offset.
  useLayoutEffect(() => {
    // Deterministic (no measuring): keep header height stable per-variant.
    const val = `${Math.max(0, fallback)}px`;
    document.documentElement.style.setProperty('--mobile-search-header-h', val);
    return () => {
      document.documentElement.style.setProperty('--mobile-search-header-h', '0px');
    };
  }, [fallback]);

  return <MobileSearchHeader {...props} />;
}
